import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ToolsService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getToolsData() {
        return this.httpClient.get(environment.api.base + 'trainings/dates');
    }
    getLastTrainingDate() {
        return this.httpClient.get(environment.api.base + 'trainings/date');
    }
    getTrainModels() {
        return this.httpClient.get(environment.api.base + 'trainings/models');
    }
}
ToolsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ToolsService_Factory() { return new ToolsService(i0.ɵɵinject(i1.HttpClient)); }, token: ToolsService, providedIn: "root" });
